import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

/**
 * Reusable Template Selector Component
 * Dropdown to select equipment template
 */
const TemplateSelector = ({ templates, value, onChange, disabled = false }) => {
  const { t } = useLanguage();
  return (
    <div className='bg-blue-50 p-4 rounded-lg'>
      <label className='block text-sm font-medium text-blue-800 mb-2'>
        {t('templateSelector.useTemplateOptional')}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className='input-field'
        disabled={disabled}
      >
        <option value=''>{t('templateSelector.createFromScratch')}</option>
        {templates.map((tpl) => (
          <option key={tpl.id} value={tpl.id}>
            {t('templateSelector.templateOptionLabel', {
              name: tpl.name,
              count: tpl.parts_data?.length || 0,
            })}
            {tpl.brand && ` • ${tpl.brand}`}
          </option>
        ))}
      </select>
      {value && (
        <p className='text-sm text-blue-600 mt-2'>
          {t('templateSelector.partsWillBeLoaded')}
        </p>
      )}
    </div>
  );
};

export default TemplateSelector;
